// extracted by mini-css-extract-plugin
export default {"Card":"CardSection_Card__ml39Y","content":"CardSection_content__+pZQr","button":"CardSection_button__XNJMu","logo1":"CardSection_logo1__e9rqe"};